// The download-service payload for the max-diff block, ported from the coffee block (onExport).
// The block hands it straight to the download service - the whole payload, including which file
// and export type to ask for, is resolved here.

import { humanizedFiltersString } from '@aytm/app/stats/lib/stat-page'
import { questionIdToPosition } from '@aytm/app/stats/page/components/lib/utils'
import PageGlobals from '@aytm/app/stats/lib/page/page-globals'

// The label of a per-screen measure names how many items a respondent saw, which only the
// question knows.
const ITEMS_PER_SET_TOKEN = '{{itemsPerSet}}'

// The link a virtual item points at wins over the question's own key.
const resolvePosition = (link, fallback) => (0 < link?.length && questionIdToPosition(link)) || fallback

// Only a measure-bound download carries provenance; the rest ask for the file alone.
const calcExtra = ({ exportMethod, exportMethodText, itemsPerSet, link, visualPosition }) => {
  if (!exportMethod) return {}

  return {
    user: PageGlobals.USERNAME,
    qid: link || `q${visualPosition}`,
    method: exportMethod,
    methodText: exportMethodText?.replace(ITEMS_PER_SET_TOKEN, itemsPerSet) || '',
    filters: humanizedFiltersString(),
    customDomain: PageGlobals.SUBDOMAIN
  }
}

export const calcDownloadParams = ({
  fileType,
  exportType,
  exportMethod,
  exportMethodText,
  itemsPerSet,
  link,
  questionKey,
  visualPosition
} = {}) => ({
  fileType,
  exportType,
  exportOptions: {
    position: resolvePosition(link, questionKey),
    extra: calcExtra({ exportMethod, exportMethodText, itemsPerSet, link, visualPosition })
  }
})
